import React from "react";
import { formatDate } from "../../../Utils/utils";

export default function TableRow({ brand, onBrandClick }) {
  return (
    <tr className="pending-brands__table-row">
      <td className="pending-brands__logo-cell">
        <div className="pending-brands__logo-container">
          <img
            src={brand.logo}
            className="pending-brands__logo"
            alt="brand logo"
          />
        </div>
      </td>
      <td className="pending-brands__text">{brand.name}</td>
      <td className="pending-brands__text">
        {formatDate(brand.createdAt.seconds)}
      </td>
      <td className="pending-brands__table-data">
        <button
          type="button"
          className="btn pending-brands__button"
          data-toggle="modal"
          data-target="#review_modal"
          onClick={() => onBrandClick(brand)}
        >
          View Manifest
        </button>
      </td>
    </tr>
  );
}



// WEBPACK FOOTER //
// ./src/screens/PendingCommunities/components/TableRow.jsx